export default __webpack_public_path__ + "static/media/ica-margot_&_dunes.e11d97fc.jpg";